export const getActivationActionType = (isDeleteMode) => {
    return isDeleteMode ? "Deactivated" : "Activated";
};

export const trackDownloadAndDeleteActivity = ({
    trackActivity,
    isSuccessOnDownload,
    downloadItemId,
    isSuccessOnDeleteCA,
    isDeleteMode,
    entityId,
}) => {
    if (!!isSuccessOnDownload) {
        trackActivity({
            activitySuccess: !!isSuccessOnDownload,
            actionType: "Downloaded",
            itemId: downloadItemId || "",
        });
    }

    if (!!isSuccessOnDeleteCA) {
        trackActivity({
            activitySuccess: !!isSuccessOnDeleteCA,
            actionType: getActivationActionType(!!isDeleteMode),
            itemId: entityId || "",
        });
    }
};
